package com.ives.modules.crosssection;
class CardinalSpline {
	public static function getCurvePoints(points:Array<Float>, ?tension:Float = 0.5, ?numOfSeg:UInt = 25, ?close:Bool = false):Array<Float> {
		var pts:Array<Float>, // for cloning point array
		i = 1,
		l = points.length,
		rPos:UInt = 0,
		rLen = (l-2) * numOfSeg + 2 + (close ? 2 * numOfSeg: 0),
		res = new Array<Float>(),
		cache = new Array<Float>(),
		cachePtr = 4;

		pts = points.slice(0);

		if (close) {
			pts.unshift(points[l - 1]); // insert end point as first point
			pts.unshift(points[l - 2]);
			pts.push(points[0]); // first point as last point
			pts.push(points[1]);
		}
		else {
			pts.unshift(points[1]); // copy 1. point and insert at beginning
			pts.unshift(points[0]);
			pts.push(points[l - 2]); // duplicate end-points
			pts.push(points[l - 1]);
		}

		// cache inner-loop calculations as they are based on t alone
		cache[0] = 1; // 1,0,0,0
		cache[1] = 0;
		cache[2] = 0;
		cache[3] = 0;

		for(i in 1...numOfSeg){
			var st = i / numOfSeg,
			st2 = st * st,
			st3 = st2 * st,
			st23 = st3 * 2,
			st32 = st2 * 3;

			cache[cachePtr++] =	st23 - st32 + 1;		// c1
			cache[cachePtr++] =	st32 - st23;			// c2
			cache[cachePtr++] =	st3 - 2 * st2 + st;		// c3
			cache[cachePtr++] =	st3 - st2;				// c4
		}

		cache[++cachePtr] = 1; // 0,1,0,0

		// calc. points
		var i = 2;

		while(i < l){
			var pt1 = pts[i],
			pt2 = pts[i+1],
			pt3 = pts[i+2],
			pt4 = pts[i+3],

			t1x = (pt3 - pts[i-2]) * tension,
			t1y = (pt4 - pts[i-1]) * tension,
			t2x = (pts[i+4] - pt1) * tension,
			t2y = (pts[i+5] - pt2) * tension,
			c = 0, c1, c2, c3, c4;

			for(t in 0...numOfSeg){
				c1 = cache[c++];
				c2 = cache[c++];
				c3 = cache[c++];
				c4 = cache[c++];

				res[rPos++] = c1 * pt1 + c2 * pt3 + c3 * t1x + c4 * t2x;
				res[rPos++] = c1 * pt2 + c2 * pt4 + c3 * t1y + c4 * t2y;
			}

			i += 2;
		}

		if (close) {
			//l = points.length;
			pts = [];
			pts.push(points[l - 4]);
			pts.push(points[l - 3]);
			pts.push(points[l - 2]);
			pts.push(points[l - 1]);
			pts.push(points[0]);
			pts.push(points[1]);
			pts.push(points[2]);
			pts.push(points[3]);

			var i = 2;

			while(i < l){
				var pt1 = pts[i],
				pt2 = pts[i+1],
				pt3 = pts[i+2],
				pt4 = pts[i+3],

				t1x = (pt3 - pts[i-2]) * tension,
				t1y = (pt4 - pts[i-1]) * tension,
				t2x = (pts[i+4] - pt1) * tension,
				t2y = (pts[i+5] - pt2) * tension,
				c = 0, c1, c2, c3, c4;

				for(t in 0...numOfSeg){
					c1 = cache[c++];
					c2 = cache[c++];
					c3 = cache[c++];
					c4 = cache[c++];

					res[rPos++] = c1 * pt1 + c2 * pt3 + c3 * t1x + c4 * t2x;
					res[rPos++] = c1 * pt2 + c2 * pt4 + c3 * t1y + c4 * t2y;
				}

				i += 2;
			}
		}

		// add last point
		l = close ? 0 : points.length - 2;
		res[rPos++] = points[l++];
		res[rPos] = points[l];

		return removeNans(res);
	}

	private static function removeNans(values:Array<Float>):Array<Float>{
		var noNans:Array<Float> = [];

		for(value in values)
			if(!Math.isNaN(value))
				noNans.push(value);

		return noNans;
	}
}
